export default "__VITE_ASSET__cDjf_gzt__"